import { Component, Input } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [NgStyle, NgClass],
})
export class SpinnerComponent {
  @Input() size: 'extra-small' | 'small' | 'medium' | 'large' = 'large';
  @Input() align: string = 'center';
}
